import { useEffect } from "react"
import { useHistory, useParams } from "react-router";
import useSaveLibraryCode from "../../modules/user/hooks/use-save-library-code";
import { getHomeRoute } from "../routes";

export default function LandingPage() {

    const history = useHistory();
    const {code} = useParams<{code: string}>();
    const saveLibraryCode = useSaveLibraryCode();

    useEffect(() => {
        saveLibraryCode(code || '');
        history.replace(getHomeRoute());
    }, [saveLibraryCode, code, history])

    return <></>
}
